var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  11\n\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/demo/index.vue?vue&type=template&id=53501194&scoped=true
// module id = null
// module chunks = 